import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import CustomAlert from "../../../components/Alert/CustomAlert";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ul: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
  }),
);

interface UnknownProductAlertProps {
  className?: string;
}

function UnknownProductAlert(props: UnknownProductAlertProps) {
  const classes = useStyles();
  const { className } = props;

  return (
    <CustomAlert severity="info" className={className} text="">
      <div>
        Unknown products should only be used in case of:
        <ul className={classes.ul}>
          <li>Unknown Competitor Products</li>
          <li>Unlisted tesa Products</li>
          <li>Undefined (Found) tesa Products</li>
        </ul>
      </div>
    </CustomAlert>
  );
}

export default UnknownProductAlert;
